import React from "react";
import { ShieldCheck } from "lucide-react";
import LegalFooter from "@/components/LegalFooter";

export const AuthShell = ({ title, subtitle, children, testId, wide }) => (
  <div data-testid={testId} className="grain flex min-h-screen flex-col items-center justify-center bg-[#0a0e17] px-4 py-10 text-slate-100">
    <div className={`w-full ${wide ? "max-w-2xl" : "max-w-md"} rounded-2xl border border-slate-800/80 bg-[#131a2a] p-8 shadow-2xl fade-up`}>
      <div className="mb-6 flex items-center gap-3">
        <img src="/ruach-logo.jpg" alt="R.U.A.C.H." className="h-12 w-12 rounded-lg object-cover ring-1 ring-orange-500/30" />
        <div>
          <h1 className="font-display text-xl font-bold leading-none tracking-tight">R.U.A.C.H.</h1>
          <p className="text-[11px] text-slate-500">Registration Utility &amp; Automated Certificate Hub</p>
        </div>
      </div>
      <h2 className="font-display text-lg font-semibold">{title}</h2>
      {subtitle && <p className="mt-1 mb-5 text-sm text-slate-400">{subtitle}</p>}
      {children}
      <p className="mt-6 flex items-center justify-center gap-1.5 text-[11px] text-slate-600">
        <ShieldCheck className="h-3.5 w-3.5 text-emerald-500" /> Your company's data is isolated and encrypted in transit.
      </p>
    </div>
    <div className="w-full max-w-2xl">
      <LegalFooter compact />
    </div>
  </div>
);

export const Field = ({ label, testId, ...props }) => (
  <div>
    <label className="mb-1 block text-xs font-medium text-slate-400">{label}</label>
    <input
      data-testid={testId}
      {...props}
      className="w-full rounded-lg border border-slate-700 bg-slate-900/60 px-3 py-2.5 text-sm text-slate-100 placeholder:text-slate-600 outline-none focus:border-orange-500"
    />
  </div>
);

export const ErrorBox = ({ error, testId = "auth-error" }) =>
  error ? (
    <div data-testid={testId} className="rounded-lg border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-300">{error}</div>
  ) : null;

export const PrimaryButton = ({ children, testId, ...props }) => (
  <button
    data-testid={testId}
    {...props}
    className="flex w-full items-center justify-center gap-2 rounded-xl bg-orange-600 py-2.5 font-semibold text-white transition-colors hover:bg-orange-500 disabled:opacity-60"
  >
    {children}
  </button>
);
